import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ExacteraLogo from "../../assets/svgs/exactera-primary-logo.svg";
import tokens from "../../styles/designTokens";
import { theme } from "../../styles/theme";

const useStyles = makeStyles(() => ({
  footer: {
    backgroundColor: tokens.white,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.75rem',
  },
  executionId: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  poweredBy: {
    ...theme.typography.caption,
    color: tokens.neutral100,
    fontSize: '0.75rem',
    textTransform: 'uppercase',
  },
  padding: {
    height: '1.5rem',
    backgroundColor: tokens.white
  }
}));

interface ExactReportFooterProps {
  executionId?: string;
}

const ExactReportFooter: React.FC<ExactReportFooterProps> = ({ executionId }) => {
  const classes = useStyles();

  return (
    <div className={classes.footer}>
      {executionId &&
        <div className={classes.executionId}>
          <Typography>Execution ID:</Typography>
          <Typography variant="caption">{executionId}</Typography>
        </div>
      }
      <div className={classes.poweredBy}>
        Powered By
      </div>
      <div>
        <Typography variant="caption">
          &copy; <ExacteraLogo aria-label="Exactera Logo" />
        </Typography>
      </div>
      <div className={classes.padding}></div>
    </div>
  );
};

export default ExactReportFooter;
